import { motion } from 'motion/react';

interface ProductivityPulseProps {
  isRunning: boolean;
}

export function ProductivityPulse({ isRunning }: ProductivityPulseProps) {
  if (!isRunning) {
    return (
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <div className="w-3 h-3 rounded-full bg-muted-foreground/40" />
        <span className="font-medium">Pausado</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-sm text-red-400">
      <motion.div
        className="w-3 h-3 rounded-full bg-red-500"
        animate={{ scale: [1, 1.4, 1], opacity: [1, 0.6, 1] }}
        transition={{ duration: 1.2, repeat: Infinity, ease: 'easeInOut' }}
      />
      <span className="font-semibold uppercase tracking-wide">Perdiendo productividad</span>
    </div>
  );
}
